import AxiosService from '../AxiosService';
import { queryString, apiUrl } from '../config/globals';

export const planListView = (data, params) => AxiosService.post(`${apiUrl('plan', 'private')}/search?${queryString(params)}`, data);

export const addPlan = (data) => AxiosService.post(`${apiUrl('plan', 'private')}/save`, data);

export const updatePlan = (data) => AxiosService.put(`${apiUrl('plan', 'private')}/update`, data);

export const activatePlan = (data) => AxiosService.put(`${apiUrl('plan', 'private')}/activation?${queryString(data)}`);

export const viewPlan = (data) => AxiosService.get(`${apiUrl('plan', 'private')}/view?${queryString(data)}`);
